import { TRANSLATIONS, TONE_COLORS, TONE_ORDER, TONE_LEVEL } from "@/i18n";

export const ToneSelector = ({ lang, tone, onChange }) => {
  const t = TRANSLATIONS[lang];
  return (
    <div className="mb-10 sm:mb-12">
      <div className="flex items-center gap-3 mb-4">
        <span className="dossier-tag font-bold">{t.toneLabel}</span>
        <span className="flex-1 h-px bg-black/15" />
      </div>
      <div className="flex flex-wrap gap-2.5 sm:gap-3" data-testid="tone-selector">
        {TONE_ORDER.map((toneKey) => {
          const isActive = tone === toneKey;
          return (
            <button
              key={toneKey}
              data-testid={`tone-${toneKey}`}
              onClick={() => onChange(toneKey)}
              aria-pressed={isActive}
              className={`inline-flex items-center gap-2 border-2 border-black px-3 sm:px-4 py-2 font-bold text-sm transition-all ${
                isActive
                  ? "nb-shadow -translate-x-0.5 -translate-y-0.5"
                  : "bg-white nb-shadow-sm hover:-translate-y-0.5 hover:-translate-x-0.5 hover:nb-shadow"
              }`}
              style={isActive ? { background: TONE_COLORS[toneKey] } : undefined}
            >
              <span className="font-mono text-[10px] tracking-widest text-[#4A4A4A]">
                {TONE_LEVEL[toneKey]}
              </span>
              <span>{t.tones[toneKey]}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};
